<template>
  <base-nav class="navbar-top navbar-dark" id="navbar-main" :show-toggle-button="false" expand>
    <form class="navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto"></form>
    <ul class="navbar-nav align-items-center d-none d-md-flex">
      <li class="nav-item dropdown">
        <base-dropdown class="nav-link pr-0">
          <div class="media align-items-center" slot="title">
            <span class="avatar avatar-sm rounded-circle d-none">
              <img alt="Image placeholder" src="img/theme/team-4-800x800.jpg" />
            </span>
            <div class="media-body ml-2 d-none d-lg-block">
              <a href="#" style="color: white;"><span class="mb-0 text-sm  font-weight-bold">{{
                getName
              }}</span></a>
              <br>
              <small>{{ smsCount.toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}}
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="gold">
                  <circle cx="12" cy="12" r="10" stroke="orange" stroke-width="2" fill="gold" />
                  <text x="12" y="16" text-anchor="middle" font-size="12" fill="orange" font-weight="bold">$</text>
                </svg>
              </small>
            </div>

          </div>

          <template>
            <div class="dropdown-header noti-title">
              <h6 class="text-overflow m-0">Welcome!</h6>
            </div>
            <a href="#" class="dropdown-item pointer" @click="logout()">
              <i class="ni ni-user-run"></i>
              <span>Logout</span>
            </a>
          </template>
        </base-dropdown>
      </li>
    </ul>
  </base-nav>
</template>
<script>
import router from "../router";
import axios from "axios";

export default {
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      searchQuery: "",
      smsCount: "",
    };
  },
  computed: {
    getName: function () {
      return localStorage.name;
    },
  },
  mounted() {
    this.getCurrentCredit()
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    logout() {
      localStorage.clear();
      sessionStorage.clear();
      router.push("/login");
    },
    getCurrentCredit: function () {
      var localApp = this;
      axios
        .get("/api/dashboard/credit", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function (response) {
          localApp.smsCount = response.data.smsCount
        })
        .catch(function (e) {
          console.log(e);
        });
    },
  },
};
</script>
<style scoped>
.text-sm {
  font-size: 1.1rem !important;
}
</style>
